import { IncomingMessage } from 'http';
import { NextApiRequest } from 'next';

export const isNextApiRequest = (
	req: NextApiRequest | IncomingMessage
): req is NextApiRequest => {
	return (req as NextApiRequest).body !== undefined;
};
